var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Item',{staticClass:"py-3 -my-2",class:{
    'w-full': _vm.width === '1:1',
    'w-1/2': _vm.width === '1:2',
    'w-1/3': _vm.width === '1:3',
    'w-1/4': _vm.width === '1:4',
  },staticStyle:{"color":"var(--contrastColor, black)"},attrs:{"item":_vm.item,"parent":_vm.parent}},[_c('hr',{ref:"hr",class:[_vm.style]})])}
var staticRenderFns = []

export { render, staticRenderFns }